//
//
//
//
//
//
//

export default {
  name: "Button",
  props: {
    onClick: {
      type: [Function, null],
      required: false,
      default: null
    },
    light: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'default'
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    clickHandler() {
      return this.onClick || void (0);
    }
  }
}
